interface PropsType {
  style?: React.CSSProperties;
  color?: string;
  width?: number | string;
  height?: number | string;
}

const BridgeArrowLIcon = ({ style, color = '#065D9F', width = 13, height = 20 }: PropsType) => (
  <svg width={width} height={height} viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M2 2L10 10L2 18" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export default BridgeArrowLIcon;
